<template>
  <div class="Login-Content">
    <div class="return" @click="Home">
      <img src="../assets/imgs/return.png" alt="" srcset="" />
      <p>返回首页</p>
    </div>
    <div class="Newlogin">
      <div class="NewLogin-tit">
        账号登录
      </div>
      <div class="NewLogin-txt" style="margin-top:0;">
        <el-input
          placeholder="请输入企业代码"
          v-model="toid"
          class="bordernone"
        />
      </div>
      <div class="NewLogin-txt">
        <el-input placeholder="用户" v-model="username" class="bordernone" />
      </div>
      <div class="NewLogin-txt">
        <el-input
          placeholder="密码"
          type="password"
          v-model="password"
          class="bordernone"
        />
      </div>
      <div style="text-align: center;">
        <el-button size="mini" class="NewLogin-Btn" @click="Login"
          >登 录</el-button
        >
      </div>
      <p class="login_tip" style="text-align: center;">密码忘记请联系客服</p>
    </div>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  data() {
    return {
      toid: "",
      username: "",
      password: ""
    };
  },
  methods: {
    Login() {
      const Loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let chars =
        "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"; //随机字符串
      let timer = parseInt(new Date().getTime() / 1000); //时间戳
      let appid = "minigrojch"; //appid
      let appsecret = "gmSgJjz1FjADGMX998hUndewwLSnupBp"; //appserret
      let length = 32;
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      let str = `appid=${appid}&appsecret=${appsecret}&nonce=${result}&time=${timer}&toid=${
        this.toid
      }&username=${this.username}&password=${this.$sha256(
        this.password + "7badf6a22c7378349e26b125ed8f7603"
      )}`;
      let sign = md5(str || "");
      console.log(this.$sha256(this.password));
      this.$axios
        .Getdata(
          `LoginAction.aspx?toid=${this.toid}&username=${
            this.username
          }&password=${this.$sha256(
            this.password + "7badf6a22c7378349e26b125ed8f7603"
          )}&sign=${sign}&appid=${appid}&nonce=${result}&time=${timer}`
        )
        .then(data => {
          //console.log(data);
          Loading.close();
          let res = data.data;

          if (res.errcode == "0") {
            // debugger
            window.location.href = `${window.location.origin}/${res.url}`;
          } else {
            this.$notify.error({
              title: "登录失败",
              message: `${res.errmsg}`,
              duration: 1500
            });
          }
        })
        .catch(res => {
          Loading.close();
          this.$notify.error({
            title: "请求超时",
            message: `请求超时,请稍后重试`,
            duration: 1500
          });
        });
    },
    Home() {
      window.location.href = `${window.location.origin}/GuanWang/index.html`;
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
  padding: 0;
}

.loginbtn {
  margin-top: 20px;
}

.NewLogin-txt .el-input__inner {
  border: 1px transparent !important;
  border: none !important;
}

.Login-Content {
  height: 100vh;
  width: 100%;
  background-image: url("../assets/imgs/New_Login_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  min-width: 1280px;
}

.login_pt {
  width: 300px;
  background: #fff;
  color: #000;
  text-align: center;
}

.bordernone {
  border: none !important;
  border-bottom: 1px solid #cecece;
}

::v-deep.el-input__inner {
  border-color: transparent !important;
  border-bottom: 1px solid #cecece !important;
}

.Newlogin {
  width: 300px;
  height: 400px;
  position: fixed;
  right: 200px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 0 0 10px #cecece;
}

.NewLogin-tit {
  font-size: 20px;
  padding: 50px 0;
  text-align: center;
}

.NewLogin-txt {
  width: 230px;
  height: 40px;
  margin: 0 auto;
  margin-top: 20px;
}

.NewLogin-Btn {
  background-image: linear-gradient(to right, #7197ee, #2f60fa);
  width: 260px;
  height: 40px;
  margin: 0 auto;
  line-height: 40px;
  text-align: center;
  margin-top: 20px;
  border-radius: 4px;
  padding: 0;
  font-size: 14px;
  color: #fff;
}

.NewLogin-return {
  position: fixed;
  top: 0;
  right: 20px;
}

.login_tip {
  font-size: 14px;
  color: #999;
}

.return {
  position: fixed;
  top: 20px;
  right: 60px;
  display: flex;
  display: flex;
  align-items: center;
  color: #007fff;
  cursor: pointer;
}

.return img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}
</style>
